import React from 'react';
import { Hint, ButtonV2 } from '@getgrover/ui';

import { CodeInput } from 'ggApp/shared/components/input';
import { PureTranslator } from 'ggApp/modules/translator';

import FormContainer from './formContainer';
import { FormRow, ButtonRow, HelpLink } from './styles';

const PhoneConfirmation = ({
    stepData,
    onSubmit,
    onSecondaryAction,
    formError,
    hintValues,
    onChange,
    value,
    error,
    helplink,
    address2FAStyle,
}) => {
    return (
        <FormContainer
            heading={<PureTranslator tk={stepData.heading} />}
            subHeading={<PureTranslator tk={stepData.subHeading} />}
            illustration={stepData.subjectSrc}
            formError={formError}
            onSubmit={onSubmit}
            address2FAStyle={address2FAStyle}
        >
            {stepData.tip && (
                <FormRow>
                    <Hint text={<PureTranslator tk={stepData.tip} withValues={hintValues} />} />
                </FormRow>
            )}
            <FormRow>
                <CodeInput
                    value={value}
                    error={error}
                    onChange={onChange}
                    name="phoneConfirmCode"
                    address2FAStyle={address2FAStyle}
                />
            </FormRow>

            {helplink ? (
                <ButtonRow alignToBottom>
                    <HelpLink onClick={onSecondaryAction}>
                        <PureTranslator tk={stepData.button} />
                    </HelpLink>
                </ButtonRow>
            ) : (
                <ButtonRow alignToBottom>
                    <ButtonV2 type="button" fullWidth outlined onClick={onSecondaryAction}>
                        <PureTranslator tk={stepData.button} />
                    </ButtonV2>
                </ButtonRow>
            )}
        </FormContainer>
    );
};

export default PhoneConfirmation;
